// @ts-check
import Pusher from 'pusher-js';
import api from 'utils/api';
import { getStore } from 'shared/stash';
import { newReferralReceived } from './NewReceivedReferralsActions';

// Used by capybara feature specs to wait on channel subscription
window.isPusherSessionChannelConnected = () => !!window.sessionChannelConnected;

const REQUESTING_SIGN_OUT = 'REQUESTING_SIGN_OUT';
const RECEIVE_SIGN_OUT_SUCCESS = 'RECEIVE_SIGN_OUT_SUCCESS';
const UPDATE_SUBDOMAIN_ORGANIZATION = 'UPDATE_SUBDOMAIN_ORGANIZATION';
const CONNECTING_SESSION_CHANNEL = 'CONNECTING_SESSION_CHANNEL';
const CONNECTED_SESSION_CHANNEL_SUCCESS = 'CONNECTED_SESSION_CHANNEL_SUCCESS';

export {
  REQUESTING_SIGN_OUT,
  RECEIVE_SIGN_OUT_SUCCESS,
  UPDATE_SUBDOMAIN_ORGANIZATION,
  CONNECTING_SESSION_CHANNEL,
  CONNECTED_SESSION_CHANNEL_SUCCESS,
};

const actions = {
  requestingSignOut() {
    return getStore().dispatch({ type: REQUESTING_SIGN_OUT });
  },

  receiveSignOutSuccess() {
    return getStore().dispatch({ type: RECEIVE_SIGN_OUT_SUCCESS });
  },

  updateSubdomainOrganization(payload) {
    return getStore().dispatch({
      type: UPDATE_SUBDOMAIN_ORGANIZATION,
      payload,
    });
  },

  connectingSessionChannel(payload) {
    return getStore().dispatch({ type: CONNECTING_SESSION_CHANNEL, payload });
  },

  connectedSessionChannelSuccess(payload) {
    return getStore().dispatch({
      type: CONNECTED_SESSION_CHANNEL_SUCCESS,
      payload,
    });
  },

  connectChannels({ sessionChannelId, referralChannelIds, pusherConfig }) {
    actions.connectingSessionChannel({ sessionChannelId });

    const socket = new Pusher(
      pusherConfig.pusherKey,
      pusherConfig.pusherOptions
    );

    socket.connection.bind('connected', () => {
      connectSessionChannel(socket, sessionChannelId);
      connectReferralChannels(socket, referralChannelIds);
    });
  },

  signOutAgent() {
    actions.requestingSignOut();

    return api.deleteWithoutDefaultRejectionHandling('/agents/sign_out').then(
      (response) => {
        // Add this back in when we use SPA sign-in
        // actions.receiveSignOutSuccess();
        window.location.assign('/agents/sign_in');
      },
      (error) => {
        // Just in case DELETE to sessions fails somehow.
        window.location.assign('/agents/sign_in');
      }
    );
  },
};

export default actions;

const connectReferralChannels = (socket, referralChannelIds) => {
  const referralChannels = referralChannelIds.map(
    socket.subscribe.bind(socket)
  );
  referralChannels.forEach((channel) => {
    channel.bind('new-referral', (data) => {
      getStore().dispatch(newReferralReceived(data.referralId));
    });
  });
};

const connectSessionChannel = (socket, sessionChannelId) => {
  const sessionChannel = socket.subscribe(`session-${sessionChannelId}`);
  sessionChannel.bind('pusher:subscription_succeeded', () => {
    window.sessionChannelConnected = true;
    actions.connectedSessionChannelSuccess({
      socket,
      channel: sessionChannel,
    });
  });

  sessionChannel.bind('logged-out', (data) => {
    const { session } = getStore().getState();

    // TODO: Might not need the following guard, now that race cond solved
    if (!session.signingOut) {
      window.location.assign('/agents/sign_in');
    }
  });
};
